import {
  circleColor,
  defaultCircleColorHue,
} from '@rolebase/shared/helpers/circleColor'
import { GraphColorMode, HighlightTone } from '../types'

const depthColorVariation = 5

export const getLightColor = (
  lightness: number,
  depth = 1,
  hue = defaultCircleColorHue
) => circleColor(lightness - (depth - 1) * depthColorVariation, hue)

export const getDarkColor = (
  lightness: number,
  depth = 1,
  hue = defaultCircleColorHue
) => circleColor(lightness + (depth - 1) * depthColorVariation, hue)

export const getColor = (
  mode: GraphColorMode,
  lightnessLight: number,
  lightnessDark: number,
  depth = 1,
  hue = defaultCircleColorHue
) =>
  mode === 'light'
    ? getLightColor(lightnessLight, depth, hue)
    : getDarkColor(lightnessDark, depth, hue)

// Hue of the emphasis accent, matching the --highlight-color ring (#f24911).
export const highlightHue = 15

// Hue of the vacant roles emphasis, matching its ring (#8b5cf6, see
// .rb-graph-highlight-vacant): far from the orange of "My roles", and not a
// red, which would read as an alarm.
export const vacantHighlightHue = 258

// Background of an emphasized node (see .node.highlighted-role). Lightness
// mirrors the way bgColor is built (94/16), so a filled node keeps the same
// theme and depth variations as its neighbours instead of a flat magic color.
export const getHighlightBgColor = (
  mode: GraphColorMode,
  depth = 1,
  tone: HighlightTone = 'mine'
) =>
  getColor(
    mode,
    80,
    30,
    depth,
    tone === 'vacant' ? vacantHighlightHue : highlightHue
  )
